import { Api } from '../modules/Service';

const MInventory = {
  list: () => {
    return Api('/stock_inventory/list');
  },
  add: data => {
    return Api('/stock_inventory/new', JSON.stringify(data), 'POST', 'text');
  },
  update: data => {
    return Api(
      '/stock_inventory/set/' + data.id,
      JSON.stringify(data),
      'POST',
      'text',
    );
  },
  delete: id => {
    return Api('/stock_inventory/del/' + id, {}, 'GET', 'text');
  },
  get: id => {
    return Api('/stock_inventory/get/' + id);
  },
};
export default MInventory;
